import { colors2, icons, transition, UI_BODY_SEMIBOLD_SM, UI_BODY_SEMIBOLD, UI_TAG, ButtonTertiaryCompact, ButtonSecondaryCompact, ButtonGhostV2 } from "oolib";
import React from "react";
import styled, { css } from "styled-components";
import { createHoverEffect } from "../../../../../../utils/createHoverEffect";
import { useShowFilterModuleV3 } from "../../../../../../../../components/discovery/FilterModule/hooks/useShowFilterModuleV3";
import { SaveCohortButton } from "../../../../../../../../components/discovery/FilterModule/comps/Cohorts/SaveCohortButton";

const { Funnel, Plus } = icons;

export const StyledFilterButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  border-right: 1px solid ${colors2.grey10};
  background: none;
  flex: 0 0 auto;
  ${transition('width')};
  position: relative;
  ${({ showSideBarLeft, $reducedPadding }) => !showSideBarLeft && css`
    margin-left: ${$reducedPadding ? '-16px' : '-20px'};
    padding-left: ${$reducedPadding ? '16px' : '20px'};
    ${createHoverEffect()}
  `}
`

const StyledFilterCountBadge = styled.div`
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 31px;
  background-color: ${colors2.green};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const StyledFilterCountText = styled(UI_TAG)`
  color: ${colors2.white};
  text-align: center;
  letter-spacing: 0;
`

export const FilterModuleHeader = ({ onOpen, onClose, width, showSideBarLeft, style = {}, setActiveFilters, isMobile, setAddFilterAnchorEl, setAddFilterOpen, clearFilters, hasFiltersToClear, activeFiltersCount = 0, activeFilters = [] }) => {

  const TitleTypo = isMobile ? UI_BODY_SEMIBOLD : UI_BODY_SEMIBOLD_SM;
  const { showFilterModuleV3 } = useShowFilterModuleV3();

  return (
    <StyledFilterButton
      style={{
        ...style,
        width,
        cursor: !showSideBarLeft && "pointer",
      }}
      onClick={() => {
        if (showFilterModuleV3 && !showSideBarLeft && !hasFiltersToClear) {
          setAddFilterOpen?.(prev => !prev);
        } else {
          onOpen && onOpen();
        }
      }}
      showSideBarLeft={showSideBarLeft}
      $reducedPadding={showFilterModuleV3}
    >
      {showFilterModuleV3 && !showSideBarLeft && !hasFiltersToClear ? (
        <div
          ref={setAddFilterAnchorEl}
          style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}
        >
          <Plus size={isMobile ? 20 : 16} weight="bold" color={colors2.grey80} />
          <TitleTypo style={{ color: colors2.grey80, paddingTop: "0.1rem" }}>
            Add Filter
          </TitleTypo>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
          <Funnel size={isMobile ? 20 : 16} weight="bold" color={colors2.grey80} />
          <TitleTypo style={{ color: colors2.grey80, paddingTop: "0.1rem" }}>
            Filters
          </TitleTypo>
          {!showSideBarLeft && activeFiltersCount > 0 && (
            <StyledFilterCountBadge>
              <StyledFilterCountText>{activeFiltersCount}</StyledFilterCountText>
            </StyledFilterCountBadge>
          )}
        </div>
      )}
      <div>
        {showSideBarLeft && (
          <div style={{ display: 'flex', gap: '0.6rem' }}>
            {isMobile
              ?
              <>
                <ButtonTertiaryCompact
                  responsive={true}
                  value={"Clear All"}
                  icon="X"
                  onClick={() => setActiveFilters([])}
                />
                <ButtonSecondaryCompact
                  responsive={true}
                  value={"Close"}
                  onClick={() => onClose && onClose()}
                />
              </>
              : showFilterModuleV3
                ?
                <>
                  <div
                    style={{
                      display: 'flex', gap: '0.4rem', alignItems: 'center'
                    }}
                  >
                    <SaveCohortButton activeFilters={activeFilters} />
                    {hasFiltersToClear && (
                      <ButtonTertiaryCompact
                        responsive={true}
                        value={"Clear"}
                        icon="X"
                        onClick={(e) => {
                          e.stopPropagation();
                          clearFilters?.();
                        }}
                      />
                    )}
                    <div
                      ref={setAddFilterAnchorEl}
                      style={{ display: 'inline-flex' }}
                    >
                      <ButtonTertiaryCompact
                        responsive={true}
                        value={"Add Filter"}
                        icon="Plus"
                        onClick={(e) => {
                          e.stopPropagation();
                          setAddFilterOpen?.(prev => !prev);
                        }}
                      />
                    </div>
                  </div>
                  <ButtonGhostV2
                    icon="ArrowLineLeft"
                    onClick={(e) => {
                      e.stopPropagation();
                      onClose && onClose();
                    }}
                  />
                </>
                :
                <ButtonTertiaryCompact
                  responsive={true}
                  value={"Close"}
                  onClick={() => onClose && onClose()}
                />
            }
          </div>
        )}
      </div>
    </StyledFilterButton>
  );
};